// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ApartmentOutlinedSvg from "@fishx/icons-svg/es/asn/ApartmentOutlined";
import FishxIcon from '../components/FishxIcon';

var ApartmentOutlined = function ApartmentOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ApartmentOutlinedSvg
  }));
};

ApartmentOutlined.displayName = 'ApartmentOutlined';
export default React.forwardRef(ApartmentOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ApartmentOutlined.js
// module id = 1996
// module chunks = 0